<mat-toolbar class="main-header" color="primary">
  <button (click)="toggleSidenav.emit()" mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>
  <div class="branding">
    <img src="assets/images/kidley_logo.png" alt="" />
  </div>
  <div class="search-bar" fxFlex>
    <!-- <form class="search-form" [ngStyle.xs]="{display: 'none'}">
      <mat-icon>search</mat-icon>
      <input type="text" [formControl]="stdCtrl" [matAutocomplete]="auto" placeholder="Search by Beta Version In-progress" (keydown.enter)="openStudent()"  autofocus="true"/>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)='openStudent()'>
        <mat-option *ngFor="let std of filteredStdListOptions | async" [value]="std.id">
          <span><b>{{std.stdadmno}}</b> {{std.stdname}}</span> |
          <small>{{std.stdfathrnm}}</small>
          <small> Class: <b>{{std.class}}</b></small>
          <small> Section: <b>{{std.section}}</b></small>
          <small> House: <b>{{std.house}}</b></small>
        </mat-option>
      </mat-autocomplete>
    </form> -->
  </div>
  <div style="font-size: medium;margin-right: 40px;">
    {{this.compName != undefined? this.compName:""}}
  </div>
  <div style="font-size: medium;margin-right: 50px;">
    <!-- <mat-form-field appearance="legacy" style="margin-left: 50px;width: 100px;">
      <mat-select name="food" [formControl]="currSession" style="color: white;font-weight: bold;"  (selectionChange)="onSessionChange()">
        <mat-option *ngFor="let yr of this.controllerService.fiscalyears" [value]="yr">
          {{yr.stdt | date: 'yyyy'}} - {{yr.enddt | date: 'yyyy'}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
  </div>
  <div>
    {{this.controllerService.userinfo != undefined? this.controllerService.userinfo.actual_name:""}}
  </div>
  <button (click)="fullScreenToggle()" mat-icon-button>
    <mat-icon>fullscreen</mat-icon>
  </button>
  <!-- <button (click)="toggleNotificationSidenav.emit()" mat-icon-button class="ml-xs overflow-visible">
    <mat-icon>notifications</mat-icon>
    <span class="notification-label">5</span>
  </button> -->
  <button [matMenuTriggerFor]="user" mat-icon-button class="ml-xs">
    <mat-icon>person</mat-icon>
  </button>
  <mat-menu #user="matMenu" x-position="before">
    <button mat-menu-item disabled aria-disabled="true">
      <mat-icon>settings</mat-icon>
      Settings
    </button>
    <button mat-menu-item disabled aria-disabled="true">
      <mat-icon>account_box</mat-icon>
      Profile
    </button>
    <!-- <button mat-menu-item>
      <mat-icon>notifications_off</mat-icon>
      Disable notifications
    </button> -->
    <button mat-menu-item (click)="signOut()">
      <mat-icon>exit_to_app</mat-icon>
      Sign Out
    </button>
  </mat-menu>
</mat-toolbar>